import { createAsyncThunk } from "@reduxjs/toolkit";
import { Login, LoginParams } from "../../../domain/usecases/Login";
import { Renew } from "../../../domain/usecases/Renew";
import { SendOtp, SendOtpParams } from "../../../domain/usecases/SendOtp";
import { Logout } from "../../../domain/usecases/Logout";
import { onLogoutUser } from "./AuthSlice";
import {
  LoginGmail,
  LoginGmailParams,
} from "../../../domain/usecases/LoginGmail";
import {
  RemoveAccount,
  RemoveAccountParams,
} from "../../../domain/usecases/RemoveAccount";
import { RequestRemoveAccount } from "../../../domain/usecases/RequestRemoveAccount";
import {
  SetPassword,
  SetPasswordParams,
} from "../../../domain/usecases/SetPassword";
export const onLogout = createAsyncThunk(
  "auth/logout",
  async (_, { extra, dispatch }) => {
    const { logout } = extra as { logout: Logout };
    await logout.execute();
    dispatch(onLogoutUser());
    return;
  },
);
export const onSendOtp = createAsyncThunk(
  "auth/sendOtp",
  async (params: SendOtpParams, { extra }) => {
    const { sendOtp } = extra as { sendOtp: SendOtp };
    const result = await sendOtp.execute(params);
    return result;
  },
);

export const onLoginUser = createAsyncThunk(
  "auth/loginUser",
  async (params: LoginParams, { extra }) => {
    const { loginUseCase } = extra as { loginUseCase: Login };
    const result = await loginUseCase.execute(params);
    return result;
  },
);
export const onRenew = createAsyncThunk("auth/renew", async (_, { extra }) => {
  const { renew } = extra as { renew: Renew };
  const result = await renew.execute();
  return result;
});
export const onLoginGmail = createAsyncThunk(
  "auth/login-gmail",
  async (params: LoginGmailParams, { extra }) => {
    const { loginGmail } = extra as { loginGmail: LoginGmail };
    const result = await loginGmail.execute(params);
    return result;
  },
);
export const onRemoveAccount = createAsyncThunk(
  "auth/remove-account",
  async (params: RemoveAccountParams, { extra }) => {
    const { removeAccount } = extra as { removeAccount: RemoveAccount };
    await removeAccount.execute(params);
    return;
  },
);
export const onRequestRemoveAccount = createAsyncThunk(
  "auth/request-remove-account",
  async (_, { extra }) => {
    const { requestRemoveAccount } = extra as {
      requestRemoveAccount: RequestRemoveAccount;
    };
    await requestRemoveAccount.execute();
    return;
  },
);
export const onSetPassword = createAsyncThunk(
  "auth/set-password",
  async (params: SetPasswordParams, { extra }) => {
    const { setPassword } = extra as { setPassword: SetPassword };
    await setPassword.execute(params);
    return;
  },
);
